import {useEffect} from "react";
import ComicNavigationActions from "../model/ComicNavigationActions";

interface ComicKeyboardNavigationProps {
    actions: ComicNavigationActions,
    enabled?: boolean
}

export function useComicKeyboardNavigation(props: ComicKeyboardNavigationProps): void {
    const {actions, enabled = true} = props;

    useEffect(() => {
        if (!enabled) return;

        const handleKeyDown = (event: KeyboardEvent): void => {
            if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
                return;
            }

            switch (event.key) {
                case 'ArrowLeft':
                    actions.goToPrevious?.();
                    break;
                case 'ArrowRight':
                    actions.goToNext?.();
                    break;
                case 'Home':
                    actions.goToFirst?.();
                    break;
                case 'End':
                    actions.goToLatest?.();
                    break;
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [actions, enabled]);
}

export default useComicKeyboardNavigation;
